import { Typography } from '@sravni/react-design-system';
import React from 'react';

import { Card1, Card2, Card3 } from 'shared/assets';

export const vitrinsCardsConfig = [
  {
    title: <Typography.Heading level={5}>Всего&nbsp;одна&nbsp;анкета в&nbsp;несколько&nbsp;банков</Typography.Heading>,
    img: Card1,
    id: 1,
  },
  {
    title: <Typography.Heading level={5}>Максимальная сумма, которую&nbsp;вам&nbsp;одобрят</Typography.Heading>,
    img: Card2,
    id: 2,
  },
  {
    title: <Typography.Heading level={5}>Предложения от&nbsp;топовых&nbsp;банков</Typography.Heading>,
    img: Card3,
    id: 3,
  },
];
